export const CROP_PLANTING_CALENDARS_LIST_VIEW = "/crop-planting-calendars"
export const CROP_PLANTING_CALENDAR_VIEW = `${CROP_PLANTING_CALENDARS_LIST_VIEW}/:cropPlantingCalendarId`
